import CreditMemoRequestItem from '../../Domain/CreditMemo/CreditMemoRequestItem';
import objectHelper from '../../Helpers/objectHelper';
import serviceHelper from '../../Helpers/serviceHelper';
import SearchParams from '../../Elements/SearchParams';
import CreditMemoRequestSearchParams from '../../Contents/Operations/CreditMemo/CreditMemoRequestSearchParams';
import AuthService from '../authService';

export default class CreditMemoRequestService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const authService = AuthService.getInstance();

    let url = '/api/CreditMemoRequest/GetBySearchParams/?';

    const searchParams = new SearchParams(searchItem, CreditMemoRequestSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    url += `searchParams=${searchParams.serializeForBackendCall()}`;
    url += `&clearCache=${clearCache}`;

    return authService.CallBackendFunction(url);
  }

  static GetById(id) {
    const authService = AuthService.getInstance();
    const url = `/api/CreditMemoRequest/GetByIdAsync/${id}`;
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new CreditMemoRequestItem(item));
    }
    return [];
  }

  static async GetClientInvoiceForCreditMemoRequest(clientId) {
    const authService = AuthService.getInstance();

    if (parseInt(clientId) < 1) {
      return 'Error';
    }

    const url = `/api/CreditMemoRequest/GetClientInvoiceForCreditMemoRequestAsync/${clientId}`;

    return authService.CallBackendFunction(url);
  }

  static UpsertCreditMemoRequest(item) {
    item = serviceHelper.ConvertAllPropertyToString(item);

    const JSONItem = JSON.stringify(item);
    if (item.CreditMemoRequestId !== '') {
      const url = '/api/CreditMemoRequest/EditCreditMemoRequestAsync';
      return AuthService.getInstance().CallBackendFunctionPut(url, JSONItem);
    } else {
      const url = '/api/CreditMemoRequest/PostCreditMemoRequestAsync';
      return AuthService.getInstance().CallBackendFunctionPost(url, JSONItem);
    }
  }

  static GetCreditMemoRequestEntityById(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/CreditMemoRequest/GetEntityByIdAsync/${id}`);
  }

  static GetNavigation(id) {
    const url = `/api/CreditMemoRequest/GetCreditMemoRequestNavigationAsync/${id}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static AdvanceCreditMemoRequestWorkflow(item) {
    const url = '/api/CreditMemoRequest/AdvanceCreditMemoRequestWorkflowAsync/';
    const string = objectHelper.toString(item);
    const json = JSON.stringify(string);
    return AuthService.getInstance().CallBackendFunctionPut(url, json);
  }
}
